import { RestApiDataService } from '@/services/api/RestApiDataService'

const BASE_ENTITY_URL = '/statistic/reference'

class StatisticReferenceDataService extends RestApiDataService {
  getFilialsWithPresets () {
    return this.http.get(`${this.baseEntityUrl}/filials`)
      .then((res) => res.data.data)
  }
}

export default new StatisticReferenceDataService(BASE_ENTITY_URL)
